import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_5eecb0f3 from 'nuxt_plugin_plugin_5eecb0f3' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_gtm_2e37c59f from 'nuxt_plugin_gtm_2e37c59f' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_recaptcha_5c919278 from 'nuxt_plugin_recaptcha_5c919278' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_axios_3f1b1eee from 'nuxt_plugin_axios_3f1b1eee' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_0a9400d2 from 'nuxt_plugin_pluginutils_0a9400d2' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_6b97a19d from 'nuxt_plugin_pluginrouting_6b97a19d' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_072cf6f2 from 'nuxt_plugin_pluginmain_072cf6f2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_vuescrollto_4058cd40 from 'nuxt_plugin_vuescrollto_4058cd40' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_toast_a6ba8590 from 'nuxt_plugin_toast_a6ba8590' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_storage_5c132e64 from 'nuxt_plugin_storage_5c132e64' // Source: ./storage.js (mode: 'all')
import nuxt_plugin_apollomodule_9836b956 from 'nuxt_plugin_apollomodule_9836b956' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_auth_8fed78d0 from 'nuxt_plugin_auth_8fed78d0' // Source: ../src/plugins/auth.js (mode: 'all')
import nuxt_plugin_notifications_598635e6 from 'nuxt_plugin_notifications_598635e6' // Source: ../src/plugins/notifications.js (mode: 'all')
import nuxt_plugin_tippy_7dc94c6a from 'nuxt_plugin_tippy_7dc94c6a' // Source: ../src/plugins/tippy.js (mode: 'all')
import nuxt_plugin_filters_2b4f519a from 'nuxt_plugin_filters_2b4f519a' // Source: ../src/plugins/filters.js (mode: 'all')
import nuxt_plugin_contentful_ff81bac8 from 'nuxt_plugin_contentful_ff81bac8' // Source: ../src/plugins/contentful.js (mode: 'all')
import nuxt_plugin_previewclient_07e06caf from 'nuxt_plugin_previewclient_07e06caf' // Source: ../src/plugins/preview.client.js (mode: 'client')
import nuxt_plugin_axios_54e49ad0 from 'nuxt_plugin_axios_54e49ad0' // Source: ../src/plugins/axios.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Mobiilitukku","titleTemplate":"%s | Mobiilitukku","htmlAttrs":{"lang":"fi"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Puhelimen kuoret ja tarvikkeet 1-3 vrk nopealla ILMAISELLA toimituksella. Loistava asiakaspalvelu ja suuri valikoima. Tilaa Mobiilitukusta!"},{"hid":"og:title","name":"og:title","content":"Mobiilitukku"},{"hid":"og:type","name":"og:type","content":"website"},{"hid":"og:site_name","name":"og:site_name","content":"Mobiilitukku"},{"hid":"og:image","name":"og:image","content":"\u002Fdefault-og-image.jpg"},{"hid":"og:description","name":"og:description","content":"Puhelimen kuoret ja tarvikkeet 1-3 vrk nopealla ILMAISELLA toimituksella. Loistava asiakaspalvelu ja suuri valikoima. Tilaa Mobiilitukusta!"}],"__dangerouslyDisableSanitizersByTagID":{"facebook-pixel":["innerHTML"],"facebook-pixel-noscript":["innerHTML"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"script":[{"hid":"facebook-pixel","innerHTML":"!function(b,e,f,g,a,c,d){b.fbq||(a=b.fbq=function(){a.callMethod?a.callMethod.apply(a,arguments):a.queue.push(arguments)},b._fbq||(b._fbq=a),a.push=a,a.loaded=!0,a.version=\"2.0\",a.queue=[],c=e.createElement(f),c.async=!0,c.src=g,d=e.getElementsByTagName(f)[0],d.parentNode.insertBefore(c,d))}(window,document,\"script\",\"https:\u002F\u002Fconnect.facebook.net\u002Fen_US\u002Ffbevents.js\");fbq(\"init\",\"1645760138997572\");fbq(\"track\",\"PageView\");","type":"text\u002Fjavascript","body":true},{"src":"https:\u002F\u002Fstatic.zdassets.com\u002Fekr\u002Fsnippet.js?key=613d0456-8f00-45a2-8d30-c320cd90b23f","id":"ze-snippet"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KB8R3FW')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"facebook-pixel-noscript","innerHTML":"\u003Cimg height=\"1\" width=\"1\" style=\"display:none\" src=\"https:\u002F\u002Fwww.facebook.com\u002Ftr?id=1645760138997572&ev=PageView&noscript=1\"\u002F\u003E","body":true},{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KB8R3FW&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_5eecb0f3 === 'function') {
    await nuxt_plugin_plugin_5eecb0f3(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2e37c59f === 'function') {
    await nuxt_plugin_gtm_2e37c59f(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_5c919278 === 'function') {
    await nuxt_plugin_recaptcha_5c919278(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3f1b1eee === 'function') {
    await nuxt_plugin_axios_3f1b1eee(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_0a9400d2 === 'function') {
    await nuxt_plugin_pluginutils_0a9400d2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_6b97a19d === 'function') {
    await nuxt_plugin_pluginrouting_6b97a19d(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_072cf6f2 === 'function') {
    await nuxt_plugin_pluginmain_072cf6f2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_4058cd40 === 'function') {
    await nuxt_plugin_vuescrollto_4058cd40(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_a6ba8590 === 'function') {
    await nuxt_plugin_toast_a6ba8590(app.context, inject)
  }

  if (typeof nuxt_plugin_storage_5c132e64 === 'function') {
    await nuxt_plugin_storage_5c132e64(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_9836b956 === 'function') {
    await nuxt_plugin_apollomodule_9836b956(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_8fed78d0 === 'function') {
    await nuxt_plugin_auth_8fed78d0(app.context, inject)
  }

  if (typeof nuxt_plugin_notifications_598635e6 === 'function') {
    await nuxt_plugin_notifications_598635e6(app.context, inject)
  }

  if (typeof nuxt_plugin_tippy_7dc94c6a === 'function') {
    await nuxt_plugin_tippy_7dc94c6a(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2b4f519a === 'function') {
    await nuxt_plugin_filters_2b4f519a(app.context, inject)
  }

  if (typeof nuxt_plugin_contentful_ff81bac8 === 'function') {
    await nuxt_plugin_contentful_ff81bac8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_previewclient_07e06caf === 'function') {
    await nuxt_plugin_previewclient_07e06caf(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_54e49ad0 === 'function') {
    await nuxt_plugin_axios_54e49ad0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    router.push(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
